import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import SubscribeForm from '~/scenes/footer/subscribe-form'

const NewsletterSubscribe = ({ subscribeUrl }) => {
  return (
    <div className='hide-when-small'>
      <div className='four columns'>
        <h1 className='header'>{I18n.t('layouts.footer.newsletter')}</h1>
        <div className='inner apprentus-newsletter-bloc'>
          <p className='apprentus-newsletter-paragraph'>{I18n.t('layouts.footer.newsletter_info')}</p>
          <br />
          <SubscribeForm subscribeUrl={subscribeUrl} />
        </div>
      </div>
    </div>
  )
}

NewsletterSubscribe.propTypes = {
  subscribeUrl: PropTypes.string
}

export default NewsletterSubscribe
